export default __webpack_public_path__ + "static/media/notif.3426b31c.svg";